import React, { useState, useEffect } from 'react';
import { useCart } from '../../../hooks/useCart';
import { CloseButton } from './CloseButton';

type MiniCartAddNoteProps = {
  addNoteText: string;
  editNoteText: string;
  saveNoteText: string;
  addNotePlaceholderText: string;
};

export function MiniCartAddNote({
  addNoteText,
  editNoteText,
  saveNoteText,
  addNotePlaceholderText,
}: MiniCartAddNoteProps) {
  const { getNote, updateNote: _updateNote } = useCart();
  const [isEditing, setIsEditing] = useState(false);
  const [note, setNote] = useState('');

  const [originalNote, setOriginalNote] = useState('');

  async function updateNote(note: string) {
    setOriginalNote(note);
    await _updateNote(note);
  }

  useEffect(() => {
    getNote().then((note) => {
      setNote(note);
      setOriginalNote(note)
    });
  }, []);

  async function saveNote() {
    await updateNote(note);
    setIsEditing(false);
  }

  function cancelNote() {
    setNote(originalNote);
    setIsEditing(false);
  }

  return (
    <>
      {isEditing ? (
        <>
          <div className="minicart-note-underlay" onClick={cancelNote} />
          <div className="minicart-note-editor">
            <header className="minicart-note-editor__header">
              <div className="minicart-note-editor__title">{addNoteText}</div>
              <button
                className="minicart-note-editor__cancel"
                onClick={cancelNote}
              >
                <CloseButton />
              </button>
            </header>
            <textarea
              className="minicart-note-editor__textarea"
              value={note}
              placeholder={addNotePlaceholderText}
              onChange={(e) => setNote(e.target.value)}
            />
            <button onClick={saveNote} className="minicart-note-editor__save">
              {saveNoteText}
            </button>
          </div>
        </>
      ) : null}
      <button onClick={() => setIsEditing(true)} className="minicart-add-note">
        <i className="fas fa-pencil-alt"></i>
        <div className="minicart-add-note__text">
          {note ? editNoteText : addNoteText}
        </div>
      </button>
    </>
  );
}
